import { useNavigate } from "react-router-dom";
import "../CSS/Newservices.css";
import SpotlightCard from "../Component/SpotlightCard";

const services = [
  {
    id: 1,
    icon: "⚙️",
    title: "Software Development",
    desc: "Custom software solutions designed to streamline operations and accelerate your business growth.",
    bgClass: "icon-bg-sky",
  },
  {
    id: 2,
    icon: "🖥️",
    title: "Website Development",
    desc: "We build responsive, user-friendly and high-performance websites tailored to your business goals.",
    bgClass: "icon-bg-blue",
  },
 

  {
  id: 3,
  icon: "🧠",
  title: "AI Development",
  desc: "Building intelligent systems that learn, reason, and automate using machine learning, neural networks, and data-driven algorithms",
  bgClass: "icon-bg-blue",
},
  {
    id: 4,
    icon: "📱",
    title: "App Development",
    desc: "Cross-platform mobile apps for iOS & Android with seamless UX and high performance.",
    bgClass: "icon-bg-green",
  },
   
];

function Newservices() {
  const navigate = useNavigate();

  return (
    <section className="ns-section">
      <div className="container ns-container">
        {/* Header */}
        <div className="text-center mb-5">
          <span className="ns-badge">What We Offer</span>
          <h2 className="ns-heading">Our Services</h2>
          <div className="ns-divider mx-auto mb-3" />
          <p className="ns-subtext mx-auto">
            We help you to build high-quality digital solutions and products as
            well as deliver a wide range of related professional services.
          </p>
        </div>

        {/* Cards */}
        <div className="row ns-row mb-5">
          {services.map((s, i) => (
            <div className="col-12 col-sm-6 col-xl-3 mb-4" key={s.id}>
              <div className="ns-card-wrap">
                <SpotlightCard className="ns-spotlight-card">
                  <div className="ns-card">
                    <div className="ns-card-top">
                      <div className={`ns-icon-circle ${s.bgClass}`}>
                        <span>{s.icon}</span>
                      </div>
                      <div className="ns-step-badge">0{i + 1}</div>
                    </div>

                    <h5 className="ns-card-title">{s.title}</h5>
                    <div className="ns-card-divider" />
                    <p className="ns-card-desc">{s.desc}</p>
                    <span className="ns-card-arrow">Learn More →</span>
                  </div>
                </SpotlightCard>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="ns-cta d-flex flex-column flex-md-row align-items-center justify-content-between gap-4">
          <div>
            <h5 className="ns-cta-title">Ready to build something amazing?</h5>
            <p className="ns-cta-sub">
              We are available 24×7. Contact us now to start transforming your
              business.
            </p>
          </div>

          <div className="d-flex gap-3 flex-wrap flex-shrink-0 ns-cta-buttons">
            <button
              className="ns-btn-white"
              onClick={() => navigate("/services")}
            >
              View All Services
            </button>
            <button
              className="ns-btn-outline"
              onClick={() => navigate("/contact")}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Newservices;